<template>
    <div>
        <h1 class="h1">{{ $route.meta.title }}</h1>
        <div class="teacher-course-detail-list" v-if="menuOptions">
            <router-link
                v-for="(item, index) in menuOptions"
                :key="index"
                :to="{ name: item.route }"
                class="teacher-course-detail-item"
                :class="{ disabled: item.disable }"
            >
                <div class="teacher-course-detail-image">
                    <img :src="item.icon" alt="" />
                </div>
                <p class="teacher-course-detail-title">{{ item.title }}</p>
                <v-icon src="arrow-right" class="teacher-course-detail-icon" />
            </router-link>
        </div>
    </div>
</template>
<script>
let courseDetailList = [
    {
        icon: require("@/assets/teacher-cabinet/about.svg"),
        title: "Основная информация",
        name: "info",
        route: "editor-course-info",
        disable: false
    },
    {
        icon: require("@/assets/teacher-cabinet/message.svg"),
        title: "Учебный план",
        name: "plan",
        route: "editor-plan",
        disable: false
    },
    // {
    //     id: 3,
    //     icon: require("@/assets/teacher-cabinet/plan.svg"),
    //     title: "Комментарии",
    //     link: "TeacherCourseComments"
    // },
    {
        icon: require("@/assets/teacher-cabinet/payments.svg"),
        title: "Прибыль",
        name: "profit",
        route: "editor-profit",
        disable: true
    }
];
export default {
    name: "CourseEditorMenu",
    props: {
        title: String,
        id: {},
        category: String
    },
    data() {
        return {
            menuOptions: null
        };
    },
    mounted() {
        this.menuPrepare();
    },
    computed: {
        profitVisible() {
            return !(this.category === "learning" || this.$route.params.id === "creating");
        }
    },
    methods: {
        menuPrepare() {
            let disable = this.$route.params.id === "creating";
            courseDetailList.forEach(item => {
                if (item.name === "plan") {
                    item.disable = disable;
                }
            });
            this.menuOptions = courseDetailList;
            if (!this.profitVisible) {
                this.menuOptions = this.menuOptions.filter(el => el.route !== "editor-profit");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.teacher-course-detail {
    &-list {
        display: flex;
        flex-direction: row;
        /*flex-wrap: wrap;*/
        align-items: center;
        @media (max-width: 650px) {
            flex-direction: column;
        }
    }

    &-item {
        max-width: 256px;
        width: 100%;
        padding: 10px;
        height: 192px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-right: 32px;
        background: #ffffff;

        box-shadow: 0px 1px 4px rgba(57, 70, 111, 0.06), 0px 6px 20px rgba(57, 70, 111, 0.08);
        border-radius: 4px;
        &.disabled {
            background: #eee;
        }
        @media (max-width: 650px) {
            height: 56px;
            max-width: 100%;
            justify-content: space-between;
            flex-direction: row;
            box-shadow: none;
            border-bottom: 1px solid #ebeff5;
            margin-right: 0;
            padding: 0 4px 0 8px;

            &:first-child {
                border-top: 1px solid #ebeff5;
            }
        }
    }

    &-image {
        width: 64px;
        height: 64px;
        margin-bottom: 24px;

        @media (max-width: 650px) {
            display: none;
        }
    }

    &-title {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 24px;

        display: flex;
        align-items: center;
        text-align: center;

        color: #58606e;

        @media (max-width: 650px) {
            font-size: 16px;
            margin-bottom: 0;
        }
    }

    &-icon {
        display: none;

        @media (max-width: 650px) {
            display: block;
        }
    }
}
</style>
